import { ReactComponent as GleapDefaultIcon } from "../../../../Assets/DefaultLogo.svg";
import { ReactComponent as XIcon } from "../../../../Assets/x-mark.svg";
import ExpandWidgetButton from "../../../../Components/ExpandWidgetButton/ExpandWidgetButton";
import { closeWidgetAndReset } from "../../../../Components/WidgetHeader/WidgetHeader";
import { truncate } from "../../../../Helper/FeedbackItemHelper";
import { useConfigStore } from "../../../../Stores/Config";
import { useSessionStore } from "../../../../Stores/Session";

const AgentHomeV4Header = () => {
  const configStore = useConfigStore();
  const sessionStore = useSessionStore();
  const config = configStore.config;
  const isImage =
    config.bgType === "image" && !!config.bgImage && config.bgImage.length > 0;
  // Colour header only: fade the brand colour into the background across the
  // composer (default, mirrors the image header) vs. run it solid to a hard
  // edge. Same `?? true` default as the v1-v3 homes.
  const noFade = !isImage && !(config.fadebg ?? true);
  const name = truncate(sessionStore?.getName() ?? "", 18);
  const showUsername =
    typeof config.hideUsersName === "undefined" || !config.hideUsersName;

  const renderLogo = () => {
    if (config.hideLogo === true) {
      return null;
    }
    if (config.logo && config.logo.length > 0) {
      return <img className="agent-home-v4-logo" src={config.logo} alt="" />;
    }
    return <GleapDefaultIcon className="agent-home-v4-logo" />;
  };

  return (
    <div
      className={`agent-home-v4-header ${
        isImage ? "agent-home-v4-header--image" : "agent-home-v4-header--colour"
      }${noFade ? " agent-home-v4-header--nofade" : ""}`}
    >
      {isImage && (
        <>
          <img
            className="agent-home-v4-header-image"
            src={config.bgImage}
            alt=""
          />
          {/* Overscroll bleed: a mirrored copy extending above the header so a
              rubber-band bounce reveals continuous image instead of a white
              band (the colour header does the same with a ::before). */}
          <img
            className="agent-home-v4-header-image agent-home-v4-header-image--bleed"
            src={config.bgImage}
            alt=""
            aria-hidden="true"
          />
        </>
      )}
      <div className="agent-home-v4-header-overlay" />
      <div className="agent-home-v4-header-inner">
        <div className="agent-home-v4-header-bar">
          {renderLogo()}
          <div className="agent-home-v4-header-actions">
            <ExpandWidgetButton variant="home-v4" />
            <button
              type="button"
              className="agent-home-v4-header-btn"
              aria-label={configStore.translateText("close")}
              onClick={() => closeWidgetAndReset()}
            >
              <XIcon />
            </button>
          </div>
        </div>
        <div className="agent-home-v4-greeting">
          <p className="agent-home-v4-greeting-kicker">
            {configStore.translateText("hi")}
            {showUsername && name && name.length > 0 ? ` ${name}` : ""}
          </p>
          {config.welcomeText && config.welcomeText.length > 0 && (
            <h3 className="agent-home-v4-greeting-title">
              {config.welcomeText}
            </h3>
          )}
        </div>
      </div>
    </div>
  );
};

export default AgentHomeV4Header;
